import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "apps-panel__title" }, "Apps", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "apps-panel__subtitle" }, "Connect Cadrelo to your favorite applications.", -1)
const _hoisted_3 = { class: "apps-panel__app-wrapper" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "apps-panel__app-title" }, "Slack", -1)
const _hoisted_5 = {
  key: 0,
  class: "apps-panel__app-status"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Connected", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "apps-panel__app-connect" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "apps-panel__app-connect-description" }, "Enable Cadrelo updates, features and notifications in your Slack channels", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Connect")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Disconnect")
const _hoisted_13 = { class: "apps-panel__app-wrapper" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "apps-panel__app-title" }, "Jira", -1)
const _hoisted_15 = {
  key: 0,
  class: "apps-panel__app-status"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "Connected", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "apps-panel__app-connect" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "apps-panel__app-connect-description" }, "Easily search and reference Jira issues inside Cadrelo", -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Connect")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Disconnect")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_DisableSlackModal = _resolveComponent("DisableSlackModal")!
  const _component_AppAlert = _resolveComponent("AppAlert")!
  const _component_AppsPanelAppSkeleton = _resolveComponent("AppsPanelAppSkeleton")!
  const _component_FadeTransition = _resolveComponent("FadeTransition")!
  const _component_DisableJiraModal = _resolveComponent("DisableJiraModal")!
  const _component_AppPanel = _resolveComponent("AppPanel")!

  return (_openBlock(), _createBlock(_component_AppPanel, { class: "apps-panel" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      (_ctx.integrationSettingsLoaded && !_ctx.isAddingToSlack)
        ? (_openBlock(), _createBlock(_component_AppAlert, {
            key: 0,
            class: "apps-panel__app",
            icon: "slack",
            iconSize: 28
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                (_ctx.slackSettings)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                (!_ctx.slackSettings)
                  ? (_openBlock(), _createBlock(_component_AppButton, {
                      key: 0,
                      onClick: _ctx.addToSlack,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_AppButton, {
                      key: 1,
                      size: "small",
                      theme: "danger",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ModalHandlerService.open('disable-slack-modal')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }))
              ]),
              _createVNode(_component_DisableSlackModal, {
                loading: _ctx.isDisconnectingFromSlack,
                "onSlack:cancel": _cache[1] || (_cache[1] = ($event: any) => (_ctx.ModalHandlerService.close())),
                "onSlack:disconnect": _cache[2] || (_cache[2] = ($event: any) => (_ctx.disconnectSlack()))
              }, null, 8, ["loading"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_FadeTransition, {
            key: 1,
            name: "fade"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppsPanelAppSkeleton)
            ]),
            _: 1
          })),
      (_ctx.integrationSettingsLoaded && !_ctx.isAddingToJira)
        ? (_openBlock(), _createBlock(_component_AppAlert, {
            key: 2,
            class: "apps-panel__app",
            icon: "jira-blue",
            iconSize: 28
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                (_ctx.jiraSettings)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                (!_ctx.jiraSettings)
                  ? (_openBlock(), _createBlock(_component_AppButton, {
                      key: 0,
                      onClick: _ctx.addToJira,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_AppButton, {
                      key: 1,
                      size: "small",
                      theme: "danger",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ModalHandlerService.open('disable-jira-modal')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_22
                      ]),
                      _: 1
                    }))
              ]),
              _createVNode(_component_DisableJiraModal, {
                loading: _ctx.isDisconnectingFromJira,
                "onJira:cancel": _cache[4] || (_cache[4] = ($event: any) => (_ctx.ModalHandlerService.close())),
                "onJira:disconnect": _cache[5] || (_cache[5] = ($event: any) => (_ctx.disconnectJira()))
              }, null, 8, ["loading"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_FadeTransition, {
            key: 3,
            name: "fade"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppsPanelAppSkeleton)
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}